const VAT_RATE = 0.2;

const roundCurrency = (amount: number) =>
  Math.round((Number(amount || 0) + Number.EPSILON) * 100) / 100;

const formatCurrencyValue = (amount: number) =>
  roundCurrency(amount).toFixed(2).replace(/\.00$/, "");

export const addVAT = (amount: number) =>
  roundCurrency(Number(amount || 0) * (1 + VAT_RATE));

export const formatCurrency = (amount: number) =>
  `£${roundCurrency(amount).toFixed(2)}`;

export const formatServicePrice = (amount: number) =>
  `£${formatCurrencyValue(amount)}`;

export const formatCurrencyWithVAT = (amount: number) =>
  formatCurrency(addVAT(amount));

export const formatServicePriceWithVAT = (amount: number) =>
  formatServicePrice(addVAT(amount));
